import { useEffect, useState } from 'react'

import { reservationsApi } from '../api'

/**
 * Resolves billed TTC (base moteur + facture taxes) for CA booking UI.
 * Falls back to baseAmount while loading / on error.
 */
export const useCaQuotedTotal = ({
  open,
  carte,
  baseAmount,
  pax,
}) => {
  const [quotedTotal, setQuotedTotal] = useState(Number(baseAmount) || 0)
  const [quoteMeta, setQuoteMeta] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const base = Math.round((Number(baseAmount) || 0) * 100) / 100
    setQuotedTotal(base)
    if (!open || !carte?.id || !(base > 0)) {
      setQuoteMeta(null)
      return undefined
    }

    let cancelled = false
    const timer = setTimeout(async () => {
      setLoading(true)
      try {
        const quote = await reservationsApi.quote({
          id_carte: carte.id,
          amount: base,
          price_total: base,
          pax: Math.max(1, Number(pax) || 1),
          carte_type: carte.type,
        })
        if (cancelled) return
        const ttc = Math.round((Number(quote?.total_ttc) || base) * 100) / 100
        setQuotedTotal(ttc)
        setQuoteMeta(quote)
      } catch {
        if (!cancelled) {
          setQuotedTotal(base)
          setQuoteMeta(null)
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    }, 200)

    return () => {
      cancelled = true
      clearTimeout(timer)
    }
  }, [open, carte?.id, carte?.type, baseAmount, pax])

  return { quotedTotal, quoteMeta, loading }
}
